import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VMain,{staticStyle:{"background-color":"#d4d8e8"}},[_c(VContainer,{staticStyle:{"max-width":"800px","padding-top":"50px"}},[_c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"fs-5 font-weight-bold",staticStyle:{"font-size":"105px"}},[_vm._v("404")]),_c('h1',[_vm._v("Page introuvable!")]),_c(VBtn,{staticClass:"mt-5",attrs:{"color":"primary","to":"/"}},[_vm._v("Retour")])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }